import axiosInstance from './axiosConfig';

export const getAdminDashboardApi = () => axiosInstance.get('/dashboard/admin');
export const getClubDashboardApi = () => axiosInstance.get('/dashboard/club');